var _style, _path, _line, _line2, _path2, _path3, _path4, _line3, _line4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlinePaymentSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#444;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st1{fill:none;stroke:#444;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3;}\r\n\t.st2{fill:none;stroke:#444;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,6v15c0,1.1,0.9,2,2,2h22c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H5C3.9,4,3,4.9,3,6z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    y1: 19,
    x2: 29,
    y2: 19
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9,
    y1: 29,
    x2: 23,
    y2: 29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,23c0,2.1-0.7,4.6-1.8,6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,29c-1.1-1.4-1.8-3.9-1.8-6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,16H10c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1v7C23,15.6,22.6,16,22,16z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9,
    y1: 10,
    x2: 23,
    y2: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20,
    y1: 13,
    x2: 18,
    y2: 13
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -72,
    y: -576,
    className: "st3",
    width: 536,
    height: 680
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinePaymentSvgrepoCom);
export default __webpack_public_path__ + "static/media/online-payment-svgrepo-com.3cbbbdb560c5da1ff0576304e3cc61ed.svg";
export { ForwardRef as ReactComponent };